import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=1f123a7c&scoped=true"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=1f123a7c&prod&lang=stylus&scoped=true"
import style1 from "./customerInfo.vue?vue&type=style&index=1&id=1f123a7c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f123a7c",
  null
  
)

export default component.exports